/** Extract YouTube video id from common URL shapes. */
export function extractYoutubeId(input: string): string | null {
  const url = input.trim();
  if (!url) {
    return null;
  }

  try {
    const u = new URL(url, 'https://www.youtube.com');
    const host = u.hostname.replace(/^www\./, '');

    if (host === 'youtu.be') {
      const id = u.pathname.replace(/^\//, '').split('/')[0];
      return id || null;
    }

    if (host.endsWith('youtube.com')) {
      if (u.pathname.startsWith('/embed/')) {
        return u.pathname.replace(/^\/embed\//, '').split('/')[0] || null;
      }
      const v = u.searchParams.get('v');
      if (v) {
        return v;
      }
      if (u.pathname.startsWith('/shorts/')) {
        return u.pathname.replace(/^\/shorts\//, '').split('/')[0] || null;
      }
    }
  } catch {
    return null;
  }

  return null;
}

export function isDirectVideoFileUrl(url: string): boolean {
  return /\.(mp4|webm|ogg)(\?|#|$)/i.test(url.trim());
}

/**
 * Plik wideo z CMS (np. DAM) — link często nie ma rozszerzenia w ścieżce.
 * W szablonie ustaw `data-fc-media-embed-kind="file"` (video-showcase).
 */
export function shouldUseNativeVideoPlayer(url: string, embedKind: string | undefined): boolean {
  const k = embedKind?.trim();
  return k === 'file' || isDirectVideoFileUrl(url);
}

/**
 * Adres iframe embed (youtube.com/embed/…) — jeden zestaw parametrów w całej aplikacji.
 * Nie ustawiamy `controls=0` (to chowałoby kontrolki); `playsinline=1` pomaga z inline na iOS w kontekście strony.
 */
export function youtubeIframeEmbedSrc(videoId: string): string {
  const q = new URLSearchParams({
    enablejsapi: '1',
    rel: '0',
    modestbranding: '1',
    playsinline: '1',
  });
  if (typeof window !== 'undefined' && window.location?.origin && window.location.origin !== 'null') {
    q.set('origin', window.location.origin);
  }
  return `https://www.youtube.com/embed/${encodeURIComponent(videoId)}?${q.toString()}`;
}
